<template>
  <SlideIn
    :open="isOpen"
    heading="Shop"
    desktop-side="left"
    :content-padding="false"
    @close="isOpen = false"
  >
    <template #content>
      <ul class="navigation">
        <li v-for="link in navigationBarLinks" :key="link.url">
          <template v-if="hasChildLinks(link)">
            <Accordion class="navigation__dropdown" show-arrow>
              <template #header>{{ link.title }}</template>
              <template #body>
                <ul>
                  <li>
                    <a :href="link.url" class="navigation__child-link"
                      >Shop All {{ link.title }}</a
                    >
                  </li>
                  <li v-for="childLink in link.items" :key="childLink.url">
                    <a :href="childLink.url" class="navigation__child-link">{{
                      childLink.title
                    }}</a>
                  </li>
                </ul>
              </template>
            </Accordion>
          </template>
          <a v-else :href="link.url" class="navigation__link">
            {{ link.title }}
          </a>
        </li>
      </ul>
      <ul class="sub-navigation">
        <li>
          <a href="/account" class="sub-navigation__link"> Account </a>
        </li>
        <li>
          <a href="/pages/members" class="sub-navigation__link">
            Members Only.
          </a>
        </li>
        <li>
          <a href="/pages/returns" class="sub-navigation__link">Returns </a>
        </li>
        <li>
          <a href="/pages/help" class="sub-navigation__link">Help </a>
        </li>
        <li>
          <a href="/pages/sustainability" class="sub-navigation__link">
            Sustainability
          </a>
        </li>
      </ul>
      <div class="divider"></div>
      <Currency
        :options="dropdownoptions"
        :selected="currencyCode"
        title="Currency"
        class="currency-dropdown"
        @changed="handleCurrencyChange"
      />
    </template>
  </SlideIn>
</template>

<script>
import Accordion from "@/components/Accordion.vue";
import SlideIn from "@/components/SlideIn.vue";
import DropDown from "@/components/DropDown.vue";
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  name: "DesktopNavigation",
  components: {
    SlideIn,
    Accordion,
    Currency: DropDown,
  },
  data() {
    return {
      dropdownoptions: [
        {
          value: "gbp",
          label: "GBP (£)",
        },
        {
          value: "eur",
          label: "EUR (€)",
        },
        {
          value: "usd",
          label: "USD ($)",
        },
        {
          value: "aud",
          label: "AUD ($)",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("app", ["currencyCode"]),
    ...mapState("app", ["isNavOpen", "navigationBarLinks"]),
    isOpen: {
      get() {
        return this.isNavOpen;
      },
      set(val) {
        return this.setNavOpen(val);
      },
    },
  },
  methods: {
    ...mapActions("app", ["changeCurrency"]),
    handleCurrencyChange(value) {
      this.changeCurrency(value);
    },
    ...mapActions("app", ["setNavOpen"]),
    hasChildLinks(link) {
      if (link.items.length > 0) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/components/navigation";

.navigation {
  padding: 20px 0 0;

  &__link {
    padding: 15px 20px;
  }

  & > li {
    &:last-child {
      margin: 0 0 52px;
    }
  }
}

.navigation__child-link {
  padding: 10px 20px;
}

.currency-dropdown {
  padding: 0 6px;
  box-shadow: none;

  ::v-deep(.dropdown__panel) {
    position: static;
    box-shadow: none;
  }
}
</style>
